import { ApiParameter, doesNotHaveExpand, get } from "@insite/client-framework/Services/ApiService";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

export interface GetOrderApiParameter extends ApiParameter {
    orderNumber: string;
    expand?: ("orderLines" | "shipments" | "vmidetails")[];
    additionalExpands?: string[];
    sTEmail?: string;
    sTPostalCode?: string;
}

export interface UpdateOrderApiParameter extends ApiParameter {
    order: OrderModel;
}

const ordersUrl = "/api/v1/orders";

export async function getOrder(parameter: GetOrderApiParameter): Promise<OrderModel> {
    const { orderNumber, ...newParameter } = parameter;

    const order = await get<OrderModel>(`${ordersUrl}/${orderNumber}`, newParameter);
    cleanOrder(order, orderNumber, parameter);
    return order;
}

function cleanOrder(
    orderModel: OrderModel,
    orderNumber: string,
    parameter?: { expand?: string[]; additionalExpands?: string[] },
) {
    orderModel.orderDate = new Date(orderModel.orderDate);
    orderModel.erpOrderNumber = orderNumber;
    orderModel.id = orderModel.erpOrderNumber || orderModel.webOrderNumber;
    if (doesNotHaveExpand(parameter, "orderLines")) {
        delete orderModel.orderLines;
    }

    if (!orderModel.shipViaDescription) {
        delete orderModel.shipViaDescription;
    }
}
